import type { Dictionnaire } from '../type';

export const temps: Dictionnaire['temps'] = {
  ilYa: {
    instant: 'ahora mismo',
    minutes: (n: number) => `hace ${n} min`,
    heures: (n: number) => `hace ${n} h`,
    jours: (n: number) => `hace ${n} d`,
    semaines: (n: number) => `hace ${n} sem.`,
    mois: (n: number) => `hace ${n} mes${n > 1 ? 'es' : ''}`,
    ans: (n: number) => `hace ${n} año${n > 1 ? 's' : ''}`,
  },
  hier: 'ayer',
  Hier: 'Ayer',
  aujourdhui: 'Hoy',
  heure: {
    pleine: (h: number) => `${String(h).padStart(2, '0')}:00`,
    avecMinutes: (h: number, minutes: string) => `${String(h).padStart(2, '0')}:${minutes}`,
  },
  masqueDate: 'DD / MM / AAAA',
  aujourdhuiMin: 'hoy',
};
